module Geisha.Modules.RingCentralDial {
    export class Startup {
        constructor($stateProvider: ng.ui.IStateProvider, version: string) {
            $stateProvider.state("ringcentraldial", {
                url: "/ringcentral/dial?number&source",
                controller: Controllers.RingCentralDialController,
                templateUrl: "/app/modules/ringcentraldial/ringcentraldial.html?v=@version@",
                data: {
                    requireLogin: true
                }
            });
        }
    }
}
